import { render } from "./portworx-volume.vue?vue&type=template&id=2bcc1162"
import script from "./portworx-volume.vue?vue&type=script&lang=js"
export * from "./portworx-volume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__